import { EquipmentType } from '../types';

const strengthTypes = ['strength', 'fusion'];

export function isStrengthMachine(equipmentType: EquipmentType): boolean {
  return strengthTypes.includes(equipmentType);
}
